<template>
  <div class="referral-cost-input" :class="`cost-input-${inputCount}`">
    <template v-for="(info, name) in inputInfo">
      <NumberInput
        v-if="info.input"
        v-model="info.value"
        v-bind="info.inputProp"
        :key="name"
        :disabled="disabled"
        :class="errorName[name] && 'has-error'"
        :ref="`input_${name}`"
        :min="0"
      />
      <span v-else :key="name">{{ info.value|formatBigNumber }}</span>
    </template>
  </div>
</template>

<script>
import _ from 'lodash'
import NumberInput from './numberInput'

export default {
  components: {
    NumberInput
  },
  props: {
    config: {
      required: true
    },
    disabled: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      errorName: {}
    }
  },
  computed: {
    inputInfo () {
      const info = {}
      const namelist = Object.keys(this.config)
      const maxIndex = namelist.length
      _.forEach(namelist, (name, index) => {
        if (index > 0 && index < maxIndex) {
          info[`inputX_${index}`] = {
            value: 'X'
          }
        }
        info[name] = this.config[name]
        index++
      })
      return info
    },
    inputCount () {
      return _.filter(this.config, { input: true }).length
    }
  },
  created () {

  },
  methods: {
    showError (inputName) {
      this.$set(this.errorName, inputName, true)
    },
    clearError (inputName) {
      this.$set(this.errorName, inputName, false)
    }
  }
}
</script>

<style lang="scss" scoped>
.referral-cost-input {
  display: flex;
  justify-content: space-between;
  font-weight: bold;

  * {
    margin: 0 2px;

    &:first-child {
      margin-left: 0;
    }

    &:last-child {
      margin-right: 0;
    }
  }

  &.cost-input-1 {
    .number-input {
      flex: 1
    }
  }

  .number-input {
    flex: 1;

    &.el-input--prefix {
      ::v-deep {
        .el-input__inner {
          padding-left: 20px;
        }
      }
    }

    ::v-deep {
      .el-input__inner {
        height: 20px;
        line-height: inherit;
        text-align: right;
        padding: 0 3px;
        color: inherit;
      }
    }
  }
}
</style>
